import {isMobileViewport} from "./utils";

$( function() {

	adjustFullWindowElements();

	$( '.col-equal, .home .content-rows .block' ).matchHeight();

	$( '.content-animate' ).onScreen( {
		'toggleClass': 'in-view'
	} );
} );

$( window ).on( 'load', function() {
	$( 'body' ).addClass( 'loaded' );
} );

$( window ).on( 'resize', function() {
	setTimeout( function() {
		adjustFullWindowElements();
	}, 100 );
} );

$( window ).on( 'scroll', function() {
	var scrollTop = $( window ).scrollTop();

	if ( scrollTop > 5 ) {
		$( 'body' ).addClass( 'scroll' ).removeClass( 'non-scroll' );
	} else {
		$( 'body' ).removeClass( 'scroll' ).addClass( 'non-scroll' );
	}

	if ( !isMobileViewport() ) {
		$( '.block-image-container' ).each( function() {
			var $this = $( this );
			var elementOffset = $this.offset().top;
			if ( $this.hasClass( 'parallax-with-parent-offset' ) ) {
				elementOffset -= $this.parent().offset().top;
			}
			var backgroundOffset = (scrollTop - elementOffset) * .6;

			if ( scrollTop > 0 && backgroundOffset < $this.outerHeight() ) {
				$this.css( {
					'transform': 'translate3d(0, ' + backgroundOffset + 'px, 0)'
				} );

				$this.find( '.image-overlay' ).css( {
					'transform': 'translate3d(0, ' + -backgroundOffset * .4 + 'px, 0)',
					'opacity': 1 - (scrollTop * .4 / 100)
				} );
			} else {
				resetParallax();
			}
		} );
	} else {
		resetParallax();
	}
} );

function resetParallax() {
	$( '.block-image-container' ).css( {
		'transform': 'translate3d(0, 0, 0)'
	} );

	$( '.block-image-container' ).find( '.image-overlay' ).css( {
		'transform': 'translate3d(0, 0, 0)',
		'opacity': 1
	} );
}

function adjustFullWindowElements() {
	$( '.block-image-full' ).css( {
		'width': $( window ).width(),
		'height': $( window ).height()
	} );
}
